exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3wi-8DPfsIZKU7xtjfIhC1{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-item-align:center;align-self:center}html[dir=ltr] ._3wi-8DPfsIZKU7xtjfIhC1{margin-left:auto}html[dir=rtl] ._3wi-8DPfsIZKU7xtjfIhC1{margin-right:auto}._2CwC2GQEOG7UET4TmP-EE8{font-size:16px;display:-webkit-box;display:-ms-flexbox;display:flex}html[dir=ltr] ._2CwC2GQEOG7UET4TmP-EE8{margin-left:5px}html[dir=rtl] ._2CwC2GQEOG7UET4TmP-EE8{margin-right:5px}", ""]);
// Exports
exports.locals = {
	"iconWell": "_3wi-8DPfsIZKU7xtjfIhC1",
	"icon": "_2CwC2GQEOG7UET4TmP-EE8"
};